module.exports = __webpack_public_path__ + "img/20220324160539185e7z.ad62f3c2.png";